
import axios, { AxiosError, AxiosInstance } from 'axios';
import ErrorResponse from './../../../src/error-response';

import * as ServerData from './../../server-data';

export default class FiNoteWriterService {

   public static addNote(
           axiosInstance: AxiosInstance, input: ServerData.FiNoteWebWriter.AddNote$Input,
           f: (output: ServerData.FiNoteWebWriter.AddNote$Output) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'spineapi/finote/add-note',
            input.toJson()
        ).then((response) => ServerData.FiNoteWebWriter.AddNote$Output.fromJson(response.data))
       .then((output) => f(output))
       .catch(theEh);
   }


   public static tagNote(
           axiosInstance: AxiosInstance, input: ServerData.FiNoteWebWriter.TagNote$Input,
           f: (output: string) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'spineapi/finote/tag-note',
            input.toJson()
        ).then((response) => response.data as string)
       .then((output) => f(output))
       .catch(theEh);
   }


   public static unTagNote(
           axiosInstance: AxiosInstance, input: ServerData.FiNoteWebWriter.UnTagNote$Input,
           f: (output: string) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'spineapi/finote/un-tag-note',
            input.toJson()
        ).then((response) => response.data as string)
       .then((output) => f(output))
       .catch(theEh);
   }


   public static removeNote(
           axiosInstance: AxiosInstance, input: ServerData.FiNoteWebWriter.RemoveNote$Input,
           f: (output: string) => void,
           eh: ((error: AxiosError) => void)|undefined)  {
        const theEh = (eh === undefined) ?  ((error: AxiosError) => {ErrorResponse.handle(error); }) : eh;
        const config = {
            data : input.toJson()

         };
        return axiosInstance.post(
            'spineapi/finote/remove-note',
            input.toJson()
        ).then((response) => response.data as string)
       .then((output) => f(output))
       .catch(theEh);
   }


}

